import React from 'react';
import { ReferenceArrayField, SingleFieldList, ChipField } from 'react-admin';

const ParticipantsField = (props) => (
    <ReferenceArrayField source="participant_ids" reference="users" label="Participants" {...props}>
        <SingleFieldList sx={{ gap: '4px' }}>
            <ChipField source="trigram" variant="outlined" size="small" />
        </SingleFieldList>
    </ReferenceArrayField>
);

export default ParticipantsField;
